import React, { useEffect, useState } from 'react';
import { Close } from '@components/Icon';
import PropTypes from 'prop-types';

import * as styled from './styles';

function PersonModal({ person, onClose }) {
  const { name, title, email, description, imageExtended } = person;

  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 300); // match modal enter animation duration
    return () => clearTimeout(timer);
  }, []);

  return (
    <styled.ModalWrapper
      initial="enter"
      animate="center"
      exit="exit"
      variants={{
        enter: { opacity: 0 },
        center: { opacity: 1 },
        exit: { opacity: 0 },
      }}
      onClick={onClose}
    >
      <styled.Modal
        initial="enter"
        exit="exit"
        variants={{
          enter: { opacity: 0, y: 60 },
          center: { opacity: 1, y: 0 },
          exit: { opacity: 0, y: 60 },
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <styled.CloseButton onClick={onClose}>
          <Close size={28} />
        </styled.CloseButton>

        {ready && (
          <styled.ModalInner>
            <styled.SquareImageWrapper>
              <styled.SquareImage fluid={imageExtended?.image?.asset?.fluid} altText={name} />
            </styled.SquareImageWrapper>
            <styled.ModalName levels={[300, 300]}>{name}</styled.ModalName>
            <styled.ModalTitle levels={[400, 400]}>{title}</styled.ModalTitle>
            <styled.ModalDescription levels={[500, 400]}>{description}</styled.ModalDescription>
            <styled.ModalEmail href={`mailto:${email}`}>{email}</styled.ModalEmail>
          </styled.ModalInner>
        )}
      </styled.Modal>
    </styled.ModalWrapper>
  );
}

PersonModal.propTypes = {
  person: {
    name: PropTypes.string,
    email: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.object,
  },
  onClose: PropTypes.func,
};

export default PersonModal;
